import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { seconds: { type: Number, default: 15 } }

  connect() {
    this.timer = setInterval(() => Turbo.visit(window.location.href), this.secondsValue * 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
